module.exports = __webpack_public_path__ + "static/media/video_mobile.86f6249e.mp4";